import { round } from "lodash";
import dateService from "../../../../common/utils/date/date.service";
import MileageDetailsRouteWaypoint from "../common/types/mileage-details-route-waypoint";

const getDateLabel = (date: Date | null): string => {
  if (!date) {
    return `----`;
  }

  return dateService.formatDateTime(date);
};

const getDateTitle = (date: Date | null): string => {
  if (!date) {
    return ``;
  }

  return dateService.formatDateTime(date);
};

const getCompletionDateLabel = (completionDate: Date | null): string => {
  return getDateLabel(completionDate);
};

const getCompletionDateTitle = (completionDate: Date | null): string => {
  return getDateTitle(completionDate);
};

const getDistanceLabel = (distance: number | null): string => {
  if (distance === null) {
    return `----`;
  }

  const distanceAsKm = round(distance / 1000);

  return `${distanceAsKm} KM`;
};

const generateWaypointDotClassname = (
  waypoint: MileageDetailsRouteWaypoint,
  mileageUuid: string,
) => {
  return `dot-mileage-${mileageUuid}-coordinates-${waypoint.place.latitude};${waypoint.place.longitude}-stageNo-${waypoint.stageNo}`;
};

const MileageDetailsRouteHelper = {
  getCompletionDateLabel,
  getCompletionDateTitle,
  getDistanceLabel,
  generateWaypointDotClassname,
};

export default MileageDetailsRouteHelper;
